/*
 * @Author: liguokang
 * @Date: 2021-06-03 10:58:48
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2022-10-19 16:16:24
 * @Description:
 * @Copyrigh: ©2021 杭州杰竞科技有限公司 版权所有
 */
const getters = {
  getterPhone: state => state.userInfo.phone,
  getterUid: state => state.userInfo.uid,
  getterOpenId: state => state.userInfo.openId,
  getterAppId: state => state.userInfo.appId,
  getterInstId: state => state.userInfo.instId,
  organizationInfo: state => state.userInfo.organizationInfo,
  courseRsevRules: state => state.curriculaVariable.courseRsevRules,
  today: state => state.curriculaVariable.today,
  childResvedTime: state => state.curriculaVariable.childResvedTime,
  classReserveOVParms: state => {
    const { classId, courseId, teacherId } = { ...state.curriculaVariable.classReserveData.teacher };
    const { studentId, instId } = { ...state.userInfo.organizationInfo };
    const spanMins = state.curriculaVariable.fetchTeachTimeInfoOVS.classSpanMins;
    const startTime = state.curriculaVariable.studyTime;
    const reserveCourseId = courseId;
    const assetsAccountId = state.curriculaVariable.assetsAccountId;
    return { reserveCourseId, studentId, instId, classId, startTime, teacherId, spanMins, assetsAccountId };
  },
  classCanceleOV: state => {
    const { studentId, instId } = { ...state.userInfo.organizationInfo };
    const schedItemId = state.curriculaVariable.selectVal ? state.curriculaVariable.selectVal.schedItemId : null;
    return { studentId, instId, schedItemId };
  },
  techAvablTimeFrsh: state => state.curriculaVariable.techAvablTimeFrsh,
  selectVal: state => state.curriculaVariable.selectVal,
  couesrListShow: state => state.curriculaVariable.couesrListShow,
  conFreshclearAll: state => state.curriculaVariable.conFreshclearAll,
  teachRest: state => state.curriculaVariable.teachRest,
  tipsHeight: state => state.curriculaVariable.tipsHeight,
  calendarShow: state => state.curriculaVariable.calendarShow,
  stuClasAcutInfo: state => state.curriculaVariable.stuClasAcutInfo,
  mineQueueNum: state => state.curriculaVariable.mineQueueNum,
  // level: state => state.Exhibition.level,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js